import React, { useEffect, useState } from "react";

import ReactMarkdown from "react-markdown";

import {

	Card,

	CardBody,

	CardHeader,

	Collapse,

	Table,

} from "reactstrap";

import { toast } from "react-toastify";



const llmsTxtMarkdownComponents = {

	a: ({ href, children }) => (

		<a

			href={href}

			target="_blank"

			rel="noopener noreferrer"

			className="llms-txt__preview-link"

		>

			{children}

		</a>

	),

};



function downloadFile(content, filename) {

	const blob = new Blob([content], { type: "text/markdown;charset=utf-8" });

	const url = URL.createObjectURL(blob);

	const a = document.createElement("a");

	a.href = url;

	a.download = filename;

	a.click();

	URL.revokeObjectURL(url);

}



export default function LlmsTxtOutputView({ output }) {

	const [showPages, setShowPages] = useState(false);

	const [viewMode, setViewMode] = useState("preview");

	const [editedContent, setEditedContent] = useState(output?.llms_txt_content ?? "");

	const [copied, setCopied] = useState(false);



	const pages = output?.discovered_pages ?? [];



	useEffect(() => {

		setEditedContent(output?.llms_txt_content ?? "");

	}, [output?.llms_txt_content]);



	const handleCopy = async () => {

		try {

			await navigator.clipboard.writeText(editedContent);

			setCopied(true);

			setTimeout(() => setCopied(false), 2000);

		} catch {

			toast.error("Failed to copy");

		}

	};



	if (!editedContent) {

		return (

			<p className="text-muted">No llms.txt content available for this job.</p>

		);

	}



	return (

		<div className="llms-txt__output">

			<div className="llms-txt__output-toolbar" role="toolbar" aria-label="Output actions">

				<div className="llms-txt__view-toggle" role="group" aria-label="View mode">

					<button

						type="button"

						className={`llms-txt__view-toggle-btn${viewMode === "preview" ? " llms-txt__view-toggle-btn--active" : ""

							}`}

						onClick={() => setViewMode("preview")}

						aria-pressed={viewMode === "preview"}

					>

						<i className="far fa-eye" aria-hidden="true" />

						Preview

					</button>

					<button

						type="button"

						className={`llms-txt__view-toggle-btn${viewMode === "edit" ? " llms-txt__view-toggle-btn--active" : ""

							}`}

						onClick={() => setViewMode("edit")}

						aria-pressed={viewMode === "edit"}

					>

						<i className="fas fa-pencil-alt" aria-hidden="true" />

						Edit

					</button>

				</div>

				<button type="button" className="llms-txt__action-btn" onClick={handleCopy}>

					<i

						className={copied ? "fas fa-check" : "far fa-copy"}

						aria-hidden="true"

					/>

					{copied ? "Copied!" : "Copy"}

				</button>

				<button

					type="button"

					className="llms-txt__action-btn"

					onClick={() => downloadFile(editedContent, "llms.txt")}

				>

					<i className="fas fa-download" aria-hidden="true" />

					Download

				</button>

			</div>



			<Card className="llms-txt__output-card shadow-sm mb-4">

				<CardBody className="p-0">

					{viewMode === "edit" ? (
						<textarea
							className="llms-txt__output-editor"
							value={editedContent}
							readOnly
							//onChange={(e) => setEditedContent(e.target.value)}
							rows={20}
							spellCheck={false}
						/>

					) : (

						<div className="llms-txt__output-preview p-3">

							<ReactMarkdown components={llmsTxtMarkdownComponents}>

								{editedContent}

							</ReactMarkdown>

						</div>

					)}

				</CardBody>

			</Card>



			{pages.length > 0 && (

				<Card className="llms-txt__pages-card shadow-sm mb-4">

					<CardHeader className="bg-white">

						<button

							type="button"

							className="llms-txt__pages-toggle btn btn-link text-decoration-none text-dark p-0 w-100 d-flex align-items-center justify-content-between"

							onClick={() => setShowPages((v) => !v)}

						>

							<span className="fw-semibold">Discovered pages ({pages.length})</span>

							<i className={`fas fa-chevron-${showPages ? "up" : "down"} text-muted`} />

						</button>

					</CardHeader>

					<Collapse isOpen={showPages}>

						<CardBody className="pt-0">

							<div className="table-responsive">

								<Table size="sm" className="llms-txt__pages-table mb-0">

									<thead>

										<tr className="text-muted">

											<th>URL</th>

											<th>Category</th>

										</tr>

									</thead>

									<tbody>

										{pages.map((page) => {

											const pageUrl = page.url ?? page.page_url;

											return (

												<tr key={pageUrl}>

													<td className="text-break">

														<a

															href={pageUrl}

															target="_blank"

															rel="noopener noreferrer"

														>

															{pageUrl}

														</a>

													</td>

													<td>{page.category}</td>

												</tr>

											);

										})}

									</tbody>

								</Table>

							</div>

						</CardBody>

					</Collapse>

				</Card>

			)}

		</div>

	);

}


